module.exports = __webpack_public_path__ + "img/20190824114731043.e523f0ae.jpg";